import { render, staticRenderFns } from "./data-tree.vue?vue&type=template&id=ec7ea580&scoped=true"
import script from "./data-tree.vue?vue&type=script&lang=ts"
export * from "./data-tree.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7ea580",
  null
  
)

export default component.exports